import { type ApolloClient, gql } from '@apollo/client/core';
import { Query } from '../../generated/api.graphql';
import * as ApiKey from './ApiKey';

const API_KEY_FIELDS = gql`
  fragment ApiKeyFields on ApiKey {
    id
    name
    key
    expiresAt
    createdAt
  }
`;

const API_KEY_QUERY = gql`
  query ApiKey {
    me {
      apiKeys {
        ...ApiKeyFields
      }
    }
  }
  ${API_KEY_FIELDS}
`;

export const fetchApiKeys = async (client: ApolloClient<Query>): Promise<ApiKey.ApiKey> => {
  const { data } = await client.query({
    query: API_KEY_QUERY,
    fetchPolicy: 'network-only',
  });

  return data.me.apiKeys.map(ApiKey.fromGQL);
};

const API_KEY_CREATE_MUTATION = gql`
  mutation CreateApiKey($apiKeyInput: ApiKeyAttributes!) {
    createApiKey(input: { apiKey: $apiKeyInput }) {
      apiKey {
        id
        name
        key
        expiresAt
        createdAt
        keyUnmasked
      }
    }
  }
`;

export type ApiKeyInput = {
  name?: string;
};

export const createApiKey = async (client: ApolloClient<Query>, apiKeyInput: ApiKeyInput): Promise<ApiKey.ApiKey> => {
  const { data } = await client.mutate({
    mutation: API_KEY_CREATE_MUTATION,
    variables: {
      apiKeyInput,
    },
  });

  return ApiKey.fromGQL(data.createApiKey.apiKey);
};
